<template>
  <div class="cover-singer-library">
    <!-- <div class="cover-singer-library-box">
      <el-tabs v-model="renderData.activeTab" @tab-click="onTabClick">
        <el-tab-pane :label="$$t('create.library')" name="library">
        </el-tab-pane>
        <el-tab-pane
          :disabled="!userDataStore.isLogin"
          :label="$$t('create.used')"
          name="used"
        >
        </el-tab-pane>
        <el-tab-pane
          :disabled="!userDataStore.isLogin"
          :label="$$t('create.mine')"
          name="mine"
        >
        </el-tab-pane>
      </el-tabs>
    </div> -->
    <div
      class="cover-singer-library-content flex1 height-0"
      ref="referListParentBox"
    >
      <CoverList></CoverList>
    </div>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
} from "vue";

import { useRouter, useRoute } from "vue-router";

import message from "@/components/functionCallComponent/message.jsx";
import CoverList from "@/page/editor/coverVoice/coverList.vue";

import objectStorage, {
  getObjectStorageFullUrl,
} from "@/lib/objectStorage/objectStorage.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import useUserDataStore from "@/store/userDataStore.js";
const userDataStore = useUserDataStore();
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const tabCodeMap = {
  1: "library",
  2: "used",
  3: "mine",
};
const { $$language, $$t, $$tm, $$tValue } = getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {}

const Router = useRouter();
const route = useRoute();
const props = defineProps({});
const emits = defineEmits([]);
const renderData = reactive({
  activeTab: userDataStore.isLogin ? tabCodeMap[1] : tabCodeMap[1],
});

const onTabClick = (tab) => {
  renderData.activeTab = tab.props.name;
};

onMounted(() => {});
</script>
<style lang="scss">
.cover-singer-library {
  display: flex;
  flex-direction: column;
  height: 100%;
  border-radius: 0 0 16px 16px;
  background: rgba(148, 173, 255, 0.2);
  padding: 20px 0;
  .cover-singer-library-box {
    margin-bottom: 16px;
    .el-tabs {
      height: 30px;
    }
    .el-tabs__header {
      margin: 0;
      height: 30px;
    }
    .el-tabs__nav-wrap:after {
      display: none;
    }
    .el-tabs__item {
      font-family: HarmonyOS Sans SC;
      font-size: 16px;
      font-weight: 500;
      line-height: 28px;
      height: 28px;
      color: rgba(255, 255, 255, 0.5);
      padding: 0 14px;
      &.is-active {
        color: #fff;
      }
    }
    .el-tabs__active-bar {
      height: 2px;
      background: #ffffff;
    }
    .el-tabs__content {
      height: calc(100% - 30px);
    }
  }
  .cover-singer-library-content {
    height: 0;
    flex: 1;
  }
}
</style>
